export const SET_WALLBOARD_CARD = 'SET_WALLBOARD_CARD'
export const RESET_WALLBOARD_CARD = 'RESET_WALLBOARD_CARD'
